import React from "react";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import DefaultAvatar from "utils/DefaultAvatar";
import CustomAvatar from "utils/CustomAvatar";
import ConditionalWrapper from "utils/ConditionalWrapper";
import SubscribeUsersModal from "alert_subscriptions/SubscribeUsersModal";

class ManageSubsByClient extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			subscribedUsers: this.props.subscribed_users,
		};

		this.addUserCallback = this.addUserCallback.bind(this);
	}

	removeUser(event) {
		var email = event.target.parentElement.getAttribute("data-email");
		if (email && email != "") {
			let removalSuccessful = this.props.removeUser(
				email,
				this.props.section_name,
				this.props.section_id
			);
			if (removalSuccessful) {
				let subscribedUsers = [...this.state.subscribedUsers];
				subscribedUsers.splice(
					subscribedUsers.findIndex((e) => {
						return e == email;
					}),
					1
				);
				this.setState({ subscribedUsers: subscribedUsers });
			}
		}
	}

	// Since this is the component that displays subscribed users, we need a callback to this component to update it's state
	addUserCallback(email) {
		if (email && email != "" && !this.state.subscribedUsers.includes(email)) {
			let subscribedUsers = this.state.subscribedUsers;
			subscribedUsers.push(email);
			this.setState({ subscribedUsers: subscribedUsers });
		}
	}

	render() {
		let users = "";
		if (this.state.subscribedUsers.length > 0) {
			users = this.state.subscribedUsers.map((userEmail, index) => {
				let user = this.props.users[userEmail];
				if (user) {
					let avatar = (
						<DefaultAvatar
							dim="32x32"
							name={user.name}
							className="avatar"
							department={user.department}
						/>
					);
					if (user.avatar) {
						avatar = (
							<CustomAvatar
								src={user.avatar}
								className="avatar"
								department={user.department}
							/>
						);
					}
					return (
						<OverlayTrigger
							key={index}
							placement="top"
							overlay={<Tooltip>{user.name}</Tooltip>}
						>
							<div
								data-email={userEmail}
								className="d-inline-block cont mr-2 mb-1"
								onClick={(e) => this.removeUser(e)}
							>
								{avatar}
								<div className="overlay" data-email={userEmail}>
									<i
										style={{ pointerEvents: "none" }}
										className="fa fa-times"
									></i>
								</div>
							</div>
						</OverlayTrigger>
					);
				}
			});
		}

		return (
			<React.Fragment>
				<ConditionalWrapper
					condition={!this.props.section_id}
					wrapper={(children) => (
						<OverlayTrigger
							placement="top"
							overlay={<Tooltip>This service is disabled</Tooltip>}
						>
							{children}
						</OverlayTrigger>
					)}
				>
					<div
						className={!this.props.section_id ? "disabled-service" : undefined}
					>
						<div className="subscribedUsersList mt-3 pb-1">
							{users}
							<SubscribeUsersModal
								users={this.props.users}
								clientName={this.props.client_name}
								sectionName={this.props.section_name}
								sectionId={this.props.section_id}
								subscribedUsers={this.state.subscribedUsers}
								addUser={this.props.addUser}
								addUserCallback={this.addUserCallback}
							/>
						</div>
					</div>
				</ConditionalWrapper>
			</React.Fragment>
		);
	}
}

export default ManageSubsByClient;
